export const MARKETS = Object.freeze({
  DE:   'de',
  EN:   'en',
  ENCA: 'en-ca',
  ENGB: 'en-gb',
  ENIN: 'en-in',
  ENNZ: 'en-nz',
  ES:   'es',
  GI:   'gi',
  //IE:   'ie',
  JP:   'ja',
  NO:   'no',
  ROW:  'row',
  SV:   'sv',
  ROG:  'rog',
  ON:   'on',
  FI:   'fi',
} as const);
